import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {
    EnvioMuestrasLaboratorioSolicitudExInspectorViewModel,
    MotivoMuestraLaboratorioSolicitudExViewModel,
    MotivoMuestraLaboratorioExViewModel,
    ResultadoEnvioMuestraLaboratorioExViewModel,
    SolicitudLaboratorioExViewModel,
    TwResultadoEnvioMuestraLaboratorioSolicitudExViewModel,
    DocumentoMuestraLaboratorioSolicitudExViewModel,
} from './laboratorioEx.types';
import { DocumentModule, UploadedFileViewModel } from '../../../core/components/uploader/document_uploader.types';
import { DocumentUploaderService } from '../../../core/components/uploader/document-uploader.service';

@Injectable()
export class LaboratorioExService {
    private fileEndpoint = this.baseUrl + 'api/core/labdoc/';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private uploaderService: DocumentUploaderService,
    ) {}

    getSolicitudLaboratorioEx(id: number): Observable<SolicitudLaboratorioExViewModel> {
        return this.http.get<SolicitudLaboratorioExViewModel>(this.baseUrl + 'api/exportacion/LaboratorioEx/' + id).pipe();
    }

    getMotivosMuestraLaboratorioEx(): Observable<MotivoMuestraLaboratorioExViewModel[]> {
        return this.http.get<MotivoMuestraLaboratorioExViewModel[]>(this.baseUrl + 'api/exportacion/LaboratorioEx/AllMotivosMuestraEx').pipe();
    }

    getResultadosMuestraLaboratorioEx(): Observable<ResultadoEnvioMuestraLaboratorioExViewModel[]> {
        return this.http.get<ResultadoEnvioMuestraLaboratorioExViewModel[]>(this.baseUrl + 'api/exportacion/LaboratorioEx/AllResultadosMuestraEx').pipe();
    }

    saveInspectorEnvioMuestrasEx(model: EnvioMuestrasLaboratorioSolicitudExInspectorViewModel): Observable<any> {
        return this.http.post<EnvioMuestrasLaboratorioSolicitudExInspectorViewModel>(
            this.baseUrl + 'api/exportacion/LaboratorioEx/InspectorEnvioMuestrasEx',
            model,
        );
    }

    getMotivosMuestraLaboratorioByIdSolicitudEx(idSolicitudEx: number): Observable<MotivoMuestraLaboratorioSolicitudExViewModel[]> {
        return this.http
            .get<MotivoMuestraLaboratorioSolicitudExViewModel[]>(this.baseUrl + 'api/exportacion/LaboratorioEx/MotivosMuestrasByIdSolicitudEx/' + idSolicitudEx)
            .pipe();
    }

    saveResultadoEnvioMuestrasLaboratorioEx(model: TwResultadoEnvioMuestraLaboratorioSolicitudExViewModel): Observable<any> {
        return this.http.put<TwResultadoEnvioMuestraLaboratorioSolicitudExViewModel>(
            this.baseUrl + 'api/exportacion/LaboratorioEx/ResultadoEnvioMuestrasLaboratorioEx',
            model,
        );
    }

    getDocumentosLaboratorio(idSolicitudEx: number): Observable<DocumentoMuestraLaboratorioSolicitudExViewModel[]> {
        return this.http.get<DocumentoMuestraLaboratorioSolicitudExViewModel[]>(
            this.baseUrl + 'api/exportacion/LaboratorioEx/GetDocumentosLaboratorioEx/' + idSolicitudEx,
        );
    }

    persist(documentoLaboratorio: DocumentoMuestraLaboratorioSolicitudExViewModel): Observable<any> {
        if (documentoLaboratorio) {
            return this.http.post<DocumentoMuestraLaboratorioSolicitudExViewModel>(
                this.baseUrl + 'api/exportacion/LaboratorioEx/persistDocumentoMuestraLaboratorioEx',
                documentoLaboratorio,
            );
        }
        return of(null);
    }

    deleteDocumentosLaboratorio(id: number): Observable<any> {
        return this.http
            .delete<DocumentoMuestraLaboratorioSolicitudExViewModel>(this.baseUrl + 'api/exportacion/LaboratorioEx/DocumentoMuestraLaboratorioEx/' + id)
            .pipe();
    }

    getDocumentoLaboratorio(id: number): Observable<DocumentoMuestraLaboratorioSolicitudExViewModel> {
        return this.http.get<DocumentoMuestraLaboratorioSolicitudExViewModel>(this.baseUrl + 'api/exportacion/LaboratorioEx/GetDocumentoLaboratorioEx/' + id);
    }

    download(file: DocumentoMuestraLaboratorioSolicitudExViewModel): Observable<HttpResponse<Blob>> {
        const uploadedFile = new UploadedFileViewModel();
        uploadedFile.Guid = file.CodigoStorage;
        uploadedFile.Name = file.NombreArchivo;
        uploadedFile.Size = file.Size;
        delete uploadedFile.OldGuidCollection;
        delete uploadedFile.MarkToDelete;
        delete uploadedFile.Progress;

        return this.uploaderService.download(uploadedFile, DocumentModule.Laboratorio);
    }

    deleteFile(guid: string): Observable<any> {
        return this.http.delete<string>(this.fileEndpoint + guid);
    }
}
